module.exports = __webpack_public_path__ + "img/CrossChainBridge_icon4.c9a29836.svg";